export const Coord: any[] = [
    {
        region: 'head',
        camera: {x: 0.3059872269921682, y: 109.95133151284342, z: 41.92096590830642},
        target: {x: 0.3059872269921682, y: 109.95133151284342, z: 10}
    },
    {
        region: 'rightArm',
        camera: {x: -70.02231924809786, y: 72.83248977832609, z: 83.46808463737017},
        target: {x: -70.02231924809786, y: 72.83248977832609, z: -0.03289774727042616}
    },
    {
        region: 'leftArm',
        camera: {x: 80.86278892323215, y: 70.02073822499871, z: 74.83174842720165},
        target: {x: 80.86278892323215, y: 70.02073822499871, z: 0.014200299878721623}
    },
    {
        region: 'rightFoot',
        camera: {x: -38.30916155324543, y: -64.2841998504614, z: 108.2880039410639},
        target: {x: -38.30916155324543, y: -64.2841998504614, z: 1.525151842803849}
    },
    {
        region: 'leftFoot',
        camera: {x: 48.42372683276861, y: -91.66860562796234, z: 104.89172834115354},
        target: {x: 44.245985832797174, y: -66.97314356710956, z: 2.0204793714984737}
    },
];
